export default __webpack_public_path__ + "static/media/review3.a505d8fd.jpg";